// The API stores a pending OTP under the phone number or email it was sent to, so verifying must send
// that identifier back. Remember it when an OTP is requested and add it to the verify request.
const key = 'otpContact';

export function rememberOtpContact(phoneNumber?: string | null, email?: string | null): void {
  sessionStorage.setItem(key, JSON.stringify({ phoneNumber: phoneNumber || null, email: email || null }));
}

export function withOtpContact<T extends object>(request: T): T {
  const stored = JSON.parse(sessionStorage.getItem(key) ?? '{}');
  return { ...stored, ...request };
}
